import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {ENTITLEMENT_KEYS} from '@packages/domains/billing/constants';

/**
 * Determines whether a user can invite new members to the workspace.
 * This ability checks for the appropriate workspace permissions.
 * Non-admin users can invite reviewers, otherwise only
 * users with full workspace invite permissions can invite members.
 */
export const canInvite = defineAbilityConfig([
  {
    permission: ['createReviewer', 'workspaceInvite'],
  },
  {
    permission: ['create', 'workspaceInvite'],
  },
] as const);

export const canChangeProjectLink = defineAbilityConfig([
  {
    // if there is a workspace plan or site plan
    entitlements: [ENTITLEMENT_KEYS.ALLOW_PROJECT_LINK],
    // if the person's role is able to manage siteLink (determined by workspace.allowShareLinks)
    permission: ['manage', 'siteLink'],
  },
] as const);

export const canChangeSandboxLink = defineAbilityConfig([
  {
    permission: ['manage', 'siteLink'],
  },
] as const);
